(() => {
  function bridgeCheckout(event) {
    if (!Event.prototype.__rfy_stop_patch || event.defaultPrevented) return;
    const path = event.composedPath();
    const host = path.find(node => node instanceof Element && node.id === 'upCart');
    if (!host) return;
    const button = path.find(node => node instanceof Element && node.matches('button,a,input,[role="button"]') && /checkout|check\s*out|finalizar|pagamento/i.test([node.textContent,node.getAttribute('name'),node.getAttribute('href'),node.getAttribute('aria-label'),node.className].join(' ')));
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.name = 'checkout';
    proxy.hidden = true;
    proxy.setAttribute('aria-label','Checkout');
    document.body.appendChild(proxy);
    event.preventDefault();
    event.stopImmediatePropagation();
    proxy.click();
    proxy.remove();
  }
  window.addEventListener('click', bridgeCheckout, {capture:true});
})();